import { z } from 'zod';
import { CustomerType } from '../enums.js';
import { optionalString, optionalEmail } from './common.js';
/** Schéma de création d'un client (validation client + serveur). */
export const createCustomerSchema = z.object({
    firstName: z.string().trim().min(1, 'Prénom requis').max(100),
    lastName: z.string().trim().min(1, 'Nom requis').max(100),
    phone: optionalString(30),
    email: optionalEmail(),
    address: optionalString(255),
    city: optionalString(120),
    notes: optionalString(2000),
    type: z.nativeEnum(CustomerType).default(CustomerType.WALK_IN),
    discountRate: z.coerce.number().min(0).max(100).default(0),
    companyName: optionalString(150),
    taxId: optionalString(60),
});
/** Mise à jour : tous les champs optionnels. */
export const updateCustomerSchema = createCustomerSchema.partial();
//# sourceMappingURL=customer.js.map